if (!customElements.get('blog-projects')) {
  customElements.define('blog-projects', class BlogProjects extends HTMLElement {
    connectedCallback() {
      this.blogUrl = this.dataset.blogUrl;
      this.currentPage = parseInt(this.dataset.currentPage, 10) || 1;
      this.totalPages = parseInt(this.dataset.totalPages, 10) || 1;
      this.paginationType = this.dataset.paginationType || 'infinite';
      this.isLoading = false;

      this.mainImg = this.querySelector('[data-project-image]');
      this.itemsList = this.querySelector('[data-projects-list]');
      this.sentinel = this.querySelector('[data-sentinel]') || document.querySelector('[data-sentinel]');

      if (this.mainImg) {
        this.addEventListener('mouseenter', (event) => {
          const item = event.target.closest('[data-project-item]');
          if (!item) return;

          const newSrc = item.dataset.hoverImage;
          if (newSrc && this.mainImg.src !== newSrc) {
            this.mainImg.removeAttribute('srcset');
            this.mainImg.src = newSrc;
          }
        }, true);
      }

      if (this.paginationType === 'infinite' && this.sentinel && this.currentPage < this.totalPages) {
        this.initObserver();
      }
    }

    initObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoading && this.currentPage < this.totalPages) {
            this.fetchNextPage();
          }
        });
      }, {
        rootMargin: '20px 0px'
      });

      this.observer.observe(this.sentinel);
    }

    async fetchNextPage() {
      this.isLoading = true;
      const nextPage = this.currentPage + 1;
      const fetchUrl = `${this.blogUrl}?page=${nextPage}`;

      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error('Fetch failed');

        const htmlText = await response.text();
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        const newItems = doc.querySelectorAll('[data-projects-list] > [data-project-item]');

        if (newItems.length > 0 && this.itemsList) {
          newItems.forEach((item) => {
            this.itemsList.appendChild(item.cloneNode(true));
          });

          this.currentPage = nextPage;

          if (this.sentinel) {
            this.appendChild(this.sentinel);
            this.initObserver();
          }
        }

        if (this.currentPage >= this.totalPages && this.sentinel) {
          this.sentinel.remove();
        }
      } catch (error) {
        console.error('Error fetching next page:', error);
      } finally {
        this.isLoading = false;
      }
    }
  });
}